/* Colour swatches on the Eco Bike product card (snippets/product-tab-card.liquid).

   Bound once at document level, on purpose:
   facets.js replaces the grid with `current.innerHTML = incoming.innerHTML`
   on every filter change, so anything bound to the grid or a section root is
   lost after the first filter. Document delegation survives re-renders and
   works in every context the card appears in (collection grid, product tabs,
   recommendations) without each section wiring it up.

   No jQuery and no Owl dependency — the tabs script gates on owlCarousel,
   which swatches have no reason to wait for. */
(function () {
  if (window.__hpCardSwatchesBound) return;
  window.__hpCardSwatchesBound = true;

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;

    // "+ X more" / "Show less" toggle on the USP list.
    var moreBtn = target.closest('.hp-card__usps-more-btn');
    if (moreBtn) {
      evt.preventDefault();
      var uspList = moreBtn.closest('.hp-card__usps');
      if (!uspList) return;
      var expanded = uspList.classList.toggle('is-expanded');
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      moreBtn.textContent = expanded
        ? moreBtn.getAttribute('data-less-label')
        : moreBtn.getAttribute('data-more-label');
      // Expanded: "Show less" moves to the end of the list. Collapsed: back
      // inline beside the last visible bullet.
      var host;
      if (expanded) {
        var lis = uspList.querySelectorAll('li');
        host = lis[lis.length - 1];
      } else {
        var visible = uspList.querySelectorAll('li:not(.hp-card__usp--extra)');
        host = visible[visible.length - 1];
      }
      if (host && host !== moreBtn.parentElement) host.appendChild(moreBtn);
      return;
    }

    var swatch = target.closest('.hp-card__swatch');
    if (!swatch) return;

    var card = swatch.closest('.hp-card');
    if (!card) return;

    // Selection feedback always applies; the image only swaps when this
    // colour's variant actually has an image assigned in the admin.
    var swatches = card.querySelectorAll('.hp-card__swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');

    var src = swatch.getAttribute('data-variant-img');
    if (!src) return;

    var img = card.querySelector('.hp-card__img');
    if (!img) return;

    // srcset/sizes would otherwise win over the src we just set.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  });
})();
